import type { ActionContext, ActionDependencies } from './types'
import { actionService, getActionDialogClosedScript } from './action.service'
import {
  resolveActionLayoutLevelText,
  resolveActionLayoutTextId,
} from './actionScriptRuntime'

function isTruthyFlag(value: unknown): boolean {
  if (value === true || value === 1) return true
  if (value === false || value === 0) return false
  if (value == null) return false
  const text = String(value).trim().toLowerCase()
  return text === 'true' || text === '1' || text === 'yes' || text === 'y'
}

function resolveActionLayoutDisplayName(actionData: Record<string, unknown>): string {
  const desc = String(
    (actionData.description as { _text?: string })?._text ?? actionData.description ?? '',
  ).trim()
  if (desc) return desc
  const name = String(
    (actionData.name as { _text?: string })?._text ?? actionData.name ?? '',
  ).trim()
  if (name) return name
  return 'Unknown Action'
}

/** Выполнить action из `<operations>` по layout (как MAction.onActivate). */
export async function executePageLayoutAction(
  actionData: Record<string, unknown>,
  host: {
    formId: string
    panelId?: string
    elementId?: string
    platform?: string
  },
  dependencies: ActionDependencies,
): Promise<void> {
  const layout = (actionData?.layout as Record<string, unknown>) || {}
  const layoutLevel = resolveActionLayoutLevelText(layout) || 'form'
  const layoutId = resolveActionLayoutTextId(layout)
  const pageId = layoutLevel === 'page' && layoutId ? layoutId : undefined

  const attrs = actionData._attributes as { id?: string } | undefined
  const actionId = attrs?.id ?? (actionData.id as string | number | undefined) ?? '0'

  const actionContext: ActionContext = {
    id: String(actionId),
    name: resolveActionLayoutDisplayName(actionData),
    elementId:
      layoutLevel === 'element' && layoutId
        ? String(layoutId)
        : host.elementId != null
          ? String(host.elementId)
          : undefined,
    panelId: host.panelId,
    formId: host.formId,
    pageId: pageId?.toString(),
    level: (layoutLevel || 'form') as ActionContext['level'],
    data: actionData,
    platform: host.platform,
    windowType: (actionData.window__type as { _text?: string })?._text,
    onClick: (actionData.onClick as { _text?: string })?._text ?? (actionData.onClick as string | undefined),
    confirm: (actionData.confirm as { _text?: string })?._text,
    transfer: (actionData.transfer as { _text?: string })?._text ?? (actionData.transfer as string | undefined),
    transferType:
      (actionData.transferType as { _text?: string })?._text ??
      (actionData.transferType as string | undefined),
    event: {
      dialogClosed: getActionDialogClosedScript(actionData),
      chainCalled: (actionData.event as { chainCalled?: { _text?: string } })?.chainCalled?._text,
    },
    flow: (actionData.flow as { _text?: string })?._text,
    selectedData: (actionData.selected as { fields?: unknown })?.fields ?? null,
    doActionForAdjacentWindow: isTruthyFlag(
      (actionData.doActionForAdjacentWindow as { _text?: string })?._text ??
        actionData.doActionForAdjacentWindow,
    ),
  }

  await actionService.executeAction(actionContext, dependencies)
}
